export default class MessageSubject {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: MessageSubject): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): MessageSubject {
    return new MessageSubject("");
  }

  public fromJSON(value: string): MessageSubject {
    return new MessageSubject(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): MessageSubject {
    return new MessageSubject(this.value);
  }
}
